export default "__VITE_ASSET__c6dfb23d__"